import React, { Component } from 'react'
import trans from 'trans/index'
import { connect } from "react-redux"

import {css, Icon, LittleStatus, Theme} from "@bdfx/mergado-ui-kit"

import { routes } from "app/components/app";
import {
    makeAuth,
    checkToken,
} from 'app/helpers/session'
import {
    setActiveRoute,
} from "actions"
import {setTemplatesToStore} from "template-edit/reducers"
import { setProjectToStore } from "../reducers/project"
import {
    getTemplates,
    projectId,
    getProject, getProblems, getOtherDiagnostics,
} from "app/helpers/api"
import store from "store"

import {Project} from "../types/model-types";
import {OtherDiagnostics, ProblemsType} from "diagnostics/diagnostics";
import { AxiosResponse } from 'axios';
import { Template } from 'webpack';

const styles = `
            ::-webkit-scrollbar {
                display: none;
            }
             body {
                background-color: hsla(0, 0%, 100%, .5);
                margin-top: 0;
                padding: 0; !important
                font-family: Arial, Helvetica, Verdana, Sans-serif;
            }

            .document-style {
                position: static;
            }

            .widget {
                margin: 0 5px;
                width: calc(100% - 10px);
                margin-top: 7px;
                font-size: 14px;
                line-height: 19px;
                font-weight: 400;
                color: #383632;
            }

            .widget-row {
                display: table-row;
                height: 17px;
            }

            .widget-cell {
                display: table-cell;
            }

             .widget-status {
                width: 100%;
             }


            a.settings {
                display: block;
                position: absolute;
                width: 100%;
                bottom: 0;
                left: 0;
                right: 0;
                text-align: center;
                color: #009ba9;
                text-decoration: none;
            }

            a.settings:hover {
                text-decoration: underline;
            }
        `

interface Props {
    project: Project
}

interface State {
    problems: ProblemsType
    otherDiagnostics: OtherDiagnostics
}

class Widget extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            problems: null,
            otherDiagnostics: null,
        }
    }

    componentDidMount() {
        if (!checkToken(projectId)) {
            return makeAuth(projectId, location.pathname)
        }

        
        getProject()
            .then((response: any) => {
                store.dispatch(setProjectToStore(response.data))
            })

        getTemplates()
            .then((response: any) => {
                store.dispatch(setTemplatesToStore(response.data))
                store.dispatch(setActiveRoute(routes.HOME))
            })

        getProblems()
            .then((response: any) => {
                this.setState({problems: response.data})
            })
            .catch(error => console.debug('error',error))

        getOtherDiagnostics()
            .then((response: any) => {
                this.setState({otherDiagnostics: response.data})
            })
            .catch(error => console.debug('error',error))
    }


    renderContent() {
        const project  = this.props.project
        const {problems, otherDiagnostics} = this.state

        let firstStatusClass : 'warning' | 'success' = 'warning';

        if (project.active_templates_count > 0) {
            firstStatusClass = 'success'
        }

        return (
            <div className="widget">
                <div className="widget-row">
                    <div className="widget-cell widget-status">
                        <LittleStatus text={trans('active_templates')} type={firstStatusClass} title={trans('active_templates')} />
                    </div>
                    <div className="widget-cell widget-value">{project.active_templates_count}</div>
                </div>
                <div className="widget-row">
                    <div className="widget-cell widget-status">
                        <LittleStatus text={trans('inactive_templates')} type='inactive' title={trans('inactive_templates')} />
                    </div>
                    <div className="widget-cell widget-value">{project.templates_count - project.active_templates_count}</div>
                </div>
                <div className="widget-row" />
                {!!(problems && otherDiagnostics && otherDiagnostics.totalProducts && otherDiagnostics.totalProducts && otherDiagnostics.totalProducts > 0) &&
                <div className="widget-row">
                    <div className="widget-cell widget-status">
                        <StyledIcons>
                            <span title={trans('total_products')}><Icon type={'box-light'} color={Theme.steelblue} size={SmallIconsSize} text={`${otherDiagnostics.totalProducts}`} /></span>&nbsp; / &nbsp;
                            <span title={trans('with_status_ok')}><Icon type={'check-circle'} color={Theme.green} size={SmallIconsSize} text={`${otherDiagnostics.totalProducts - problems.unavailableStatusTotal - problems.unsupportedFormatOrEmptyTotal - problems.missingImagesTotal}`} /> </span>&nbsp; / &nbsp;
                            <span title={trans('with_status_error')}><Icon type={'cancel-light'} color={Theme.red} size={SmallIconsSize} text={`${problems.unavailableStatusTotal + problems.unsupportedFormatOrEmptyTotal}`} /> </span>&nbsp; / &nbsp;
                            <span title={trans('without_images')}><Icon type={'exclamation-circle'} color={Theme.blue} size={SmallIconsSize} text={`${problems.missingImagesTotal}`} /></span>
                        </StyledIcons>
                    </div>
                </div>
                }
                <div className="widget-row" />
            </div>
        );
    }


    render() {
        return (
            <div>
                <style type="text/css">{styles}</style>
                {this.renderContent()}
            </div>
        )
    }
}

const StyledIcons = css('div')({
    ' .m-image': {
        background: '#fff',
        borderRadius: '50%',
    }
})

const SmallIconsSize = 18

function mapStateToProps(state) {
    return {
        project: state.project.data
    }
}

export default connect(mapStateToProps)(Widget)